import React from 'react';
import CreditCardPage  from './../components/CreditCardPage';
import './../styles/creditCard-page.css';
const CreditCardContainer = ({history, dispatch}) => (<CreditCardPage history={history}/>);
export default CreditCardContainer;


// WEBPACK FOOTER //
// ./src/containers/CreditCardContainer.js